import React, { useEffect, useState } from "react";
import { api } from "../../Constant";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";

function Category() {
  const navigation = useNavigate();

  const [categorylist, setCategorylist] = useState([]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  useEffect(() => {
    axios
      .post(api + "category_list")
      .then((response) => {
        if (response.data.success === "true") {
          setCategorylist(response.data.category);
        } else {
          console.log("No categories found");
        }
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }, []);

  const handleClick = (item) => {
    if (item.subcategory && item.subcategory.length > 0) {
      // If subcategory exists → go to subcategory-detail
      navigation(`/subcategory/${item.category_id}`);
    } else {
      // Otherwise → go to category-page
      navigation(`/category-page/${item.category_id}`);
    }
  };

  return (
    <section className="home_category_section pt-5 pb-5">
      <div className="container">
        <div className="row first_row">
          <div className="col-12">
            <h3>
              <i>
                {/* Dress your baby in clothes that are as cute as they are comfortable */}
                From Nature's Colors to your Baby's Comfort- Clothing that cares for your little one and the earth.
              </i>
            </h3>
          </div>
        </div>

        <div
          className="row second-row"
          data-aos="fade-up"
          data-aos-offset="500"
          data-aos-easing="ease-in-sine"
        >
          {categorylist.map((item) => (
            <div
              className="col-lg-4 col-md-4 col-sm-6 grid_col"
              key={item.category_id}
            >
              <div className="inner-box">
                <div className="heading_box">
                  <h6>{item.category_name}</h6>
                </div>
                <div className="img_box">
                  <img
                    src={item.category_image}
                    style={{ width: "100%" }}
                    alt={item.category_name}
                  />
                </div>
                <div className="btn_box">
                  <button
                    onClick={() => handleClick(item)}
                    className="btn_1"
                  >
                    View Product
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Category;
